// components/FeedbackModal/styles.js
import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`

export const ModalWrapper = styled.div`
  background: white;
  padding: 30px 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 450px;
  height: 165px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  position: relative;
`

export const ModalContent = styled.div`
  text-align: left;
  padding: 10px 0px;
`

export const CloseButton = styled.div`
  ${({ theme }) => `
    mask-image: url(${process.env.REACT_APP_URL_MAIN}/Images/new-layout-gimba/icons/icon-close.svg);
    -webkit-mask-image: url(${process.env.REACT_APP_URL_MAIN}/Images/new-layout-gimba/icons/icon-close.svg);
  `}
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  width: 20px;
  height: 20px;
  background-color: #707070;
  cursor: pointer;

  position: absolute;
  top: 20px;
  right: 20px;
`

export const Title = styled.h2`
  font-family: inherit;
  color: #d22630;
  margin-bottom: 5px;
  font-size: 24px;
  font-weight: 500;
`

export const Description = styled.p`
  font-family: inherit;
  margin-top: 10px;
  font-size: 14px;
  color: #4a4a4a;
  font-weight: 400;
`
